/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright (c) 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from "react";
import PropTypes from "prop-types";
import Icon from "../Icon";
import "./Header.scss";

class Header extends React.Component {
  render() {
    return (
      <div>
        <header className="pe-proto application-header light ">
          <div className="logo">&nbsp;</div>
          <nav className="nav-links">
            <ul className="pe-list pe-list--unstyled">
              <li>
                <div className="pe-label pe-label--large">
                  <Icon
                    fileName="notification-18"
                    name="notification-18"
                    title="Notification"
                    focusable={false}
                  />
                  <Icon
                    fileName="help-fill-18"
                    name="help-fill-18"
                    title="Help"
                    focusable={false}
                  />
                </div>
              </li>
              <li>
                <div className="pe-label pe-label--large">
                  {this.props.name.length > 0 ? this.props.name : "Sign In"}
                </div>
              </li>
            </ul>
          </nav>
        </header>
      </div>
    );
  }
}

Header.propTypes = {
  name: PropTypes.string,
};

Header.defaultProps = {
  name: "",
};

export default Header;
